/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HarvestSex } from '../../models/harvest-sex';

export interface DeleteTargets$Params {
  brandName: string;
  onFarmHatchingOnly?: boolean;
  sex: HarvestSex;
}

export function deleteTargets(http: HttpClient, rootUrl: string, params: DeleteTargets$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteTargets.PATH, 'delete');
  if (params) {
    rb.query('brandName', params.brandName, {});
    rb.query('onFarmHatchingOnly', params.onFarmHatchingOnly, {});
    rb.query('sex', params.sex, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteTargets.PATH = '/api/metric-target/delete';
